import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-restricted-syntax */

export var replaceCssVars = function replaceCssVars(theme, themeTokens) {
  var newTokens = replaceVars(themeTokens, themeTokens);
  var newTheme = replaceVars(theme, newTokens);
  return [newTokens, newTheme];
};
function replaceVars(original, reference) {
  var newObj = {};
  for (var _i = 0, _Object$entries = Object.entries(original); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (_typeof(value) === 'object') {
      var newNestedObj = replaceVars(value, reference);
      newObj[key] = newNestedObj;
    } else {
      newObj[key] = replaceVar(value, reference);
    }
  }
  return newObj;
}
function replaceVar(value, reference) {
  var varMatches = value.toString().match(/var\(--lmn-ds-(.*)\)/);
  if (varMatches && varMatches[1]) {
    return reference[varMatches[1]];
  }
  return value;
}